module.exports = "/images/preparation-icon.svg";